/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tryagain1Inputs */

const en_tryagain1 = /** @type {(inputs: Tryagain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const de_tryagain1 = /** @type {(inputs: Tryagain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Tryagain1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const tryagain1 = /** @type {((inputs?: Tryagain1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tryagain1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tryagain1(inputs)
	return de_tryagain1(inputs)
});
export { tryagain1 as "tryAgain" }